import moment from 'moment'

const generateShiftPayload = (data) => {
  const { id, date, startTime, endTime, recurring, division, isPublished, resourceIds } = data

  /**
   * !!! Important !!!
   * The date & time provided are agnostic to the timezone.
   * Timezone is handled by the default value on the tenant.
   * This format is ISO standardized however
   */
  const startAt = `${date}T${startTime}`
  const endAt = `${date}T${endTime}`
  // Modeled for API here

  const recurringData = (recurring && recurring.interval === -1)
    ? null
    : recurring

  let recPayload = null
  if (recurringData){
    // start date must be the selected date
    const { endDate, interval, frequency, daysOfWeek } = recurring

    let recStartAt = `${date}T${startTime}`
    let recEndAt = `${endDate}T23:59:59`

    // If interval is 0, it means means "this week" only; Override the values set initially
    // using the range of "this week", since no start & end date are required
    if (interval === 0) {
      const momentDate = moment(date)
      recStartAt = momentDate.startOf('week').format('YYYY-MM-DDT00:00')
      recEndAt = momentDate.endOf('week').format('YYYY-MM-DDT23:59')
    }

    recurringData.startAt = recStartAt
    recurringData.endAt = recEndAt

    recPayload = {
      startAt: recStartAt,
      endAt: recEndAt,
      interval,
      frequency,
      daysOfWeek
    }
  }

  return {
    startAt,
    endAt,
    division,
    isPublished,
    recurring: recPayload,
    type: 'product',
    resourceIds
  }
}

export default {
  state: {
    shiftDialog: false,
    shiftDialogData: null
  },
  getters: {
    getShiftDialog(state) {
      return state.shiftDialog
    },
    getShiftDialogData(state) {
      return state.shiftDialogData
    }
  },
  actions: {
    deleteShift({}, data) {
      const { id, modify } = data

      const query = {
        params: { modify }
      }

      return this.$api.delete(`/api/shift/${id}`, query)
    },
    updateShift({ }, data) {
      const { id, modify } = data
      const payload = generateShiftPayload(data)

      const query = {
        params: { modify }
      }

      return this.$api.patch(`/api/shift/${id}`, payload, query)
    },
    createShift({ }, data) {
      const payload = generateShiftPayload(data)

      return this.$api.post('/api/shift', payload)
    },
    ensureShiftEntity({ dispatch, getters }){
      const { type, resourceId } = getters.getShiftDialogData || {}

      if (type === 'product') {
        const payload = { id: resourceId }
        return dispatch('ensureProduct', payload)
      } else {
        return {}
      }
    },
    setShiftDialog({ dispatch, commit  }, val) {
      commit('SET_SHIFT_DIALOG', val)
    },
    openShiftDialog({ commit }, data) {
      commit('SET_SHIFT_DIALOG', true)
      commit('SET_SHIFT_DIALOG_DATA', data)
    },
    closeShiftDialog({ commit }) {
      commit('SET_SHIFT_DIALOG', false)
      commit('SET_SHIFT_DIALOG_DATA', null)
    }
  },
  mutations: {
    SET_SHIFT_DIALOG(state, val) {
      state.shiftDialog = !!val
    },
    SET_SHIFT_DIALOG_DATA(state, data) {
      state.shiftDialogData = data
    }
  }
}

